<div style="padding: 2px; min-width: 400px;">

  <div style="margin: 2px 0;">

    <dx-text-area data-testid="comment-text-area"
      [(value)]="comment"
      [placeholder]="placeholder"
      (keyup)="onKeyUp($event)"
      height="80"
      style="width: 100%;"
      showClearButton="true"
      [isValid]="!!comment && comment.trim().length > 0"
      [validationError]="{ message: 'Comment is required.' }"
    ></dx-text-area>
  </div>
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
    <dx-button data-testid="comment-button" class="dx-button"
      text="Add Comment" 
      type="normal" 
      [disabled]="!comment || comment.trim().length === 0"
      (onClick)="onSubmit()">
    </dx-button>
    <dx-button data-testid="comment-user-button" class="user-button" text="Dismiss" type="normal" (onClick)="onDismiss()"></dx-button>
  </div>
</div>


